<template>
  <div>
    <van-nav-bar
      title="风控通知"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"

    />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
      <div v-for="(item, index) in list" :key="index">
        <van-row class="contentBg">
          <van-row style="display: flex; align-items: center">
            <!-- Dynamic Icons Based on Type -->
            <van-icon v-if="item.type === 0" name="warn-o" color="orange"/>
            <van-icon v-else-if="item.type === 1" name="fail" color="#D02E27"/>
            <van-icon v-else-if="item.type === 2" name="warn-o" color="orange" />
            <van-icon v-else-if="item.type === 3" name="bell" color="#D02E27" />
            <van-icon v-else-if="item.type === 4" name="fail" color="#D02E27"/>
            <van-icon v-else-if="item.type === 6" name="fail" color="#D02E27"/>
            <van-icon v-else-if="item.type === 7" name="warn-o" color="orange"/>
            <van-icon v-else name="circle" />

            <span class="datetext">{{ item.time }}</span>
          </van-row>
          <van-divider dashed :style="{ borderColor: 'black' }" />
          <van-row style="color: black; font-size: 13px">
            {{ item.detail }}
          </van-row>
        </van-row>
      </div>
    </van-list>

    <van-empty
      :image="require('../assets/images/empty_data.png')"
      description="暂时没有更多数据哦"
      v-if="isEmpty"
    />
  </div>
</template>

<script>
export default {
  name: "RiskControl",
  data(){
    return{
      list:[],
      loading:false,
      finished:false,
      page:1,
      isEmpty: false,
    };
  },
  methods:{
    isLogin(){
      let that = this;
      if (!that.$store.state.loginType){
        that.$router.push('/login')
      }
    },
    getList(){
      let that = this;
      let page = that.page;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "risk_control",
          num: 20,
          page: page,
          token: sessionStorage.getItem("token"),
        }
      })
        .then(function(res) {
          if (res.data.code == 1) {
            let list = that.list;
            that.page = page + 1;
            that.list = list.concat(res.data.data);
            console.log(that.list.detail);
            that.loading = false;
            if (res.data.data.length < 1) {
              that.isEmpty = true;
            }
            if (res.data.data.length < 20){
              that.finished = true;
            }
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loading = false;
          that.finished = true;
        });
    },
    updateRiskStatus() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "read_risk_control",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$store.commit("clearRiskUnreadCount");
          } else {
            // that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted:function () {
    this.isLogin();
    this.updateRiskStatus();
  },
}
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.contentBg {
  background: #f0f0f0;
  border-radius: 15px;
  padding: 20px 10px;
  margin: 10px 20px;
}

.datetext {
  color: #333333;
  padding-left: 5px;
  font-size: 15px;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/RiskControl.vue